module.exports = __webpack_public_path__ + "static/SGP-logo.cd600e9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/SGP-logo.png
// module id = 577
// module chunks = 35783957827783